var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretRoundDown = function SvgCaretRoundDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14645 1.1869C7.46143 0.871913 7.23835 0.333344 6.79289 0.333344L1.20711 0.333344C0.761654 0.333344 0.538571 0.871914 0.853553 1.1869L3.64645 3.97979C3.84171 4.17505 4.15829 4.17505 4.35355 3.97979L7.14645 1.1869Z",
    fill: "currentColor"
  })));
};
export default SvgCaretRoundDown;